import { render } from "./lookPoint.vue?vue&type=template&id=0246da88"
import script from "./lookPoint.vue?vue&type=script&lang=js"
export * from "./lookPoint.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__